import React from 'react';
import { TrialBlurImage } from '@/resources/assets/images';

interface TrialBlurModalProps {
    isOpen: boolean;
}

export const TrialBlurModal: React.FC<TrialBlurModalProps> = ({ isOpen }) => {
    if (!isOpen) return null;

    return (
        <div className="max-w-[18.75rem] rounded-2xl border border-white bg-dm-blue text-dm-white p-4 shadow-md">
          <p className="text-sm mb-3">
          To view email addresses, please upgrade your account by contacting{' '}
            <a href="mailto:human@re2.ai" className="underline text-blue-100">
              human@re2.ai
            </a>.
          </p>
          <p className="text-sm mb-4">
            But good news! You don’t need to see emails to start prospecting. Simply{' '}
            <span className="text-dm-gold font-medium">select businesses</span>,{' '}
            <span className="text-dm-gold font-medium">save them to a prospecting list</span>, and create a{' '}
            <span className="text-dm-gold font-medium">sequence</span>.
          </p>
          <img
            src={TrialBlurImage}
            alt="Prospecting UI"
            className="w-full rounded-lg border border-gray-600"
          />
        </div>
      );
    };